import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import forgotPasswordBanner from '../assets/images/forgot-password-banner.gif';
import LandingPageHeader from '../Layouts/LandingPageHeader';
import {
  email,
  renderField,
  required,
} from '../common/helpers/form-validations';
import { forgotPassword } from '../Services/Utils/UserApis';
import { notifySet } from '../Services/Actions/CommonActions';

function ForgotPassword(props) {
  const {
    handleSubmit, invalid, submitting, pristine
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = (formData) => {
    const data = {
      loginId: formData.email,
    };
    forgotPassword(data).then((res) => {
      if (res.status === true) {
        navigate(`/verify-reset-password/${res.view.resetPasswordToken}`);
        dispatch(
          notifySet({
            type: 'success',
            message: res.message,
          })
        );
      } else if (res.status === -1) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  return (
    <div id="fullpage" className="fullpage-wrapper">
      <LandingPageHeader />
      <div className="section">
        <div className="container-fluid banner-top-con full-height-section">
          <div className="container h-100">
            <div className="row h-100">
              <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
                <div className="banner-cap-left banner-top banner-top-sm">
                  <img alt="" src={forgotPasswordBanner} />
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
                <div className="banner-cap-right caption-block title-bg-text">
                  <h1>
                    <span>FORGOT</span> <br />
                    <span>PASSWORD</span>
                    <br />
                  </h1>
                  <div>
                    <form form="forgotPassword" onSubmit={handleSubmit(onSubmit)}>
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="form-group">
                            <label htmlFor="emailId">
                              Enter Email ID{' '}
                              <span className="validation-icon">*</span>
                            </label>
                            <Field
                              id="emailId"
                              name="email"
                              className="form-control"
                              placeholder="abc@xyz.com"
                              component={renderField}
                              validate={[email, required]}
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="form-group">
                            <div className="btn-con xs-full-btn mt-1">
                              <span>
                                <Button
                                  type="submit"
                                  className="btn btn-red"
                                  variant="contained"
                                  disabled={invalid || submitting || pristine}
                                >
                                  Send OTP
                                </Button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'forgotPassword',
});

export default withForm(ForgotPassword);
